var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960"}},[_c('path',{attrs:{"d":"M240-240v-401h95v232l312-312 74 74-312 312h232v95H240Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }